import classNames from 'classnames';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
export var alignmentClassName = function (componentData, theme, styles) {
    // @ts-ignore
    var alignment = (componentData.config || {}).alignment;
    if (!alignment) {
        return '';
    }
    var key = "align" + upperFirst(alignment);
    return classNames(styles[key], theme[key]);
};
export var sizeClassName = function (componentData, theme, styles) {
    // @ts-ignore
    var size = (componentData.config || {}).size;
    if (!size) {
        return '';
    }
    var key = "size" + upperFirst(camelCase(size));
    return classNames(styles[key], theme[key]);
};
export var textWrapClassName = function (componentData, theme, styles) {
    // @ts-ignore
    var textWrap = (componentData.config || {}).textWrap;
    if (!textWrap) {
        return '';
    }
    var key = "textWrap" + upperFirst(camelCase(textWrap));
    return classNames(styles[key], theme[key]);
};
//# sourceMappingURL=classNameStrategies.js.map